import React from "react";
import Container from "../../../Components/Container";
import BGImageDisplay from "../../../Components/BGImageDisplay/BGImageDisplay";
import OutageBG from "./assets/Group 421@2x.png";

const Outages = () => {
  return (
    <>
      <Container>
        <BGImageDisplay
          options={{
            objpos: "41%",
          }}
          bgimage={OutageBG}
        ></BGImageDisplay>
      </Container>
    </>
  );
};

export default Outages;
